<template>
  <div class="control-panel">
    <div style="margin-bottom: 20px;">操作台</div>
    <div>
      <el-button plain style="border:none;" @click="btnAddClue" >新建商机</el-button>
    </div>
    <div v-for="item in rightItems">
      <el-button plain style="border:none;" @click="jumpUrl(item.link)">{{item.name}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ControlPanel",
  data(){
    return {
      rightItems: [
        // {
        //   id: 0,
        //   name: "新建商机",
        //   key: "clue"
        // },
        {
          id: 1,
          name: "新建合同",
          key: "contract",
          link:"https://www.jiandaoyun.com/dashboard#/app/5f2e1e426fd1df00069b94e4/form/5f2e762a2713ef0006975cdd"
        },
        {
          id: 2,
          name: "新建订单",
          key: "order",
          link: "https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/5ee99b310286ca0006f830ed"
        },
        {
          id: 3,
          name: "新建结算",
          key: "done",
          link: "https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/5ef19943335f8500068ba5e9"
        },
        {
          id: 4,
          name: "修改数据",
          key: "data",
          link: "https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/6224d82b3c33620007db85dc"
        }
      ],
    }
  },
  methods:{
    jumpUrl(link){
      window.open(link)
    },

    // btnAddClue(){
    //   console.log('btnAddClue')
    //   let parent = this.$parent
    //   while (!parent.tabChange){
    //     parent = parent['$parent']
    //   }
    //   parent.tabChange("Business")
    // },
    btnAddClue(){
      this.$emit("addClue", "")
    }
  }
}
</script>

<style scoped>
  .control-panel{
    width:7%;
    box-shadow:0 0px 12px 0 rgb(0 0 0 / 10%);
    display: flex;
    flex-direction: column;
    align-items:center;
    justify-content: flex-start;
    padding:20px 0;
    margin-left:3%;
    height: 230px;
    position: sticky;
    top:20px;
  }
</style>